import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { ac, roles } from "./permissions";

/**
 * Better-auth client instance.
 *
 * FL-005: Access Token Silent Refresh
 * ─────────────────────────────────────
 * The SRS describes an RS256 JWT with a 15-minute TTL stored in memory, with
 * a refresh token in localStorage and a custom 401 interceptor that queues
 * parallel requests during token exchange and replays them after refresh.
 *
 * We do NOT implement this custom mechanism. Instead, we use better-auth's
 * cookie-based session management, which achieves the same security goals:
 *   - Session validation occurs on every server request
 *   - Automatic expiry handling via HttpOnly cookie TTL
 *   - No custom refresh interceptor needed — better-auth manages this transparently
 *
 * When the session expires, better-auth redirects to /login (via middleware or
 * layout guard), and the ?reason=session_expired param is appended to show the
 * appropriate toast message to the user.
 */
export const authClient = createAuthClient({
  plugins: [
    adminClient({
      ac,
      roles,
    }),
  ],
});
